<div class="overlay" *ngIf="loading">
  <div class="spinner"></div>
</div>
